import DocumentInput from './_DocumentInput';

export default DocumentInput;
